import React from 'react'

import withFade from '../../HOC/withFade'
import withQuestion from '../../HOC/withQuestion'
import { MonthlyIncomeQuestion as MonthlyIncomeQuestionV2 } from './MonthlyIncomeQuestion.v2'
import QuestionComponentProps from '../../../Questions/question-component-props'

export const MonthlyIncomeQuestion = withFade(withQuestion((props: QuestionComponentProps) => {
  return  <MonthlyIncomeQuestionV2 {...props} /> 
}))
